function parseCsvLine(line) {
  const values = [];
  let value = "";
  let quoted = false;
  for (let index = 0; index < line.length; index += 1) {
    const character = line[index];
    if (character === '"' && quoted && line[index + 1] === '"') { value += '"'; index += 1; }
    else if (character === '"') quoted = !quoted;
    else if (character === "," && !quoted) { values.push(value.trim()); value = ""; }
    else value += character;
  }
  values.push(value.trim());
  return values;
}

export function parseTradingPartyCsv(text) {
  const lines = String(text || "").replace(/^\uFEFF/, "").split(/\r?\n/).filter((line) => line.trim());
  if (lines.length < 2) throw new Error("The CSV must contain a header and at least one data row.");
  const headers = parseCsvLine(lines[0]).map((header) => header.trim().toLowerCase());
  return lines.slice(1).map((line) => Object.fromEntries(headers.map((header, index) => [header, parseCsvLine(line)[index] || ""])));
}

export function downloadTradingPartyTemplate(kind) {
  const customer = ["business_name", "customer_code", "trading_name", "email", "phone", "website", "vat_number", "company_number", "payment_terms_days", "default_currency", "default_sales_account", "default_vat_code", "credit_limit", "notes"];
  const supplier = ["name", "supplier_code", "supplier_category", "trading_name", "email", "phone", "website", "vat_number", "company_number", "payment_terms_days", "default_currency", "default_purchase_account", "default_vat_code", "bank_name", "bank_sort_code", "bank_account_number", "payment_reference", "cis_registered", "reverse_charge", "notes"];
  const headers = kind === "customer" ? customer : supplier;
  const example = kind === "customer"
    ? ["Example Customer Ltd", "CUS001", "", "accounts@example.com", "", "", "", "", "30", "GBP", "4000", "", "0", ""]
    : ["Example Supplier Ltd", "SUP001", "Trade", "", "accounts@example.com", "", "", "", "", "30", "GBP", "5000", "", "", "", "", "", "false", "false", ""];
  const blob = new Blob([`${headers.join(",")}\r\n${example.join(",")}\r\n`], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url; anchor.download = `${kind}-import-template.csv`; anchor.click();
  URL.revokeObjectURL(url);
}

export function coerceTradingPartyRow(row) {
  const next = { ...row };
  ["payment_terms_days", "credit_limit"].forEach((key) => { if (next[key] !== "" && next[key] != null) next[key] = Number(next[key]); });
  ["cis_registered", "reverse_charge"].forEach((key) => { if (next[key] !== "" && next[key] != null) next[key] = ["true", "yes", "1"].includes(String(next[key]).toLowerCase()); });
  return next;
}
